var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-carousel',{attrs:{"id":"carousel","interval":5000,"fade":"","img-height":_vm.imgHeigth,"img-width":_vm.imgWidth}},_vm._l((_vm.imagesSrc),function(image,index){return _c('b-carousel-slide',{key:index,attrs:{"img-src":image}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }